export default "__VITE_ASSET__i6BtS_2$__"